module.exports = __webpack_public_path__ + "static/media/list.565f17be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/list.svg
// module id = 840
// module chunks = 0